import {
  ConflictErrorSeverity,
  ProduceJoinConflictsErrorType,
} from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const CONFLICT_NAV_SEVERITY_COLORS: Record<
  ConflictErrorSeverity,
  string
> = {
  Critical: rydeColors.red,
  Warning: rydeColors.princetonOrange,
} as const;

export const PRODUCE_CONFLICT_NAV_SEVERITY: Partial<
  Record<ProduceJoinConflictsErrorType, ConflictErrorSeverity>
> = {
  [ProduceJoinConflictsErrorType.inactivePassenger]:
    ConflictErrorSeverity.Warning,
} as const;
